import { cookieName, getCookieValue } from 'utils/cookies'
import { CookieConsent } from './types'

const { trrCookieConsent } = cookieName
export const CURRENT_CONSENT_REVISION = 0

const generateUniqueId = (): string => Math.random().toString(36).slice(2)

const generateDefaultCookieConsent = (): CookieConsent => ({
  essential: true,
  functional: false,
  analytics: false,
  marketing: false,
  personalization: false,
  id: generateUniqueId(),
  revision: CURRENT_CONSENT_REVISION,
})

const parseRawCookieConsent = (
  cookieConsent: string
): CookieConsent | undefined => {
  try {
    return JSON.parse(decodeURIComponent(cookieConsent)) as CookieConsent
  } catch (error) {
    console.error('Error parsing cookie consent', error)
    return undefined
  }
}

const getUpdatedCookieConsent = (
  cookieConsent: CookieConsent,
  updates: Partial<CookieConsent>
): CookieConsent => ({
  ...cookieConsent,
  ...updates,
  timestamp: Date.now(),
})

export const getInitialCookieConsent = (): CookieConsent | undefined => {
  const rawCookieConsent = getCookieValue(trrCookieConsent)
  const parsedConsent = rawCookieConsent
    ? parseRawCookieConsent(rawCookieConsent)
    : undefined

  return parsedConsent && parsedConsent.revision === CURRENT_CONSENT_REVISION
    ? parsedConsent
    : generateDefaultCookieConsent()
}

export const getAllApprovedCookieConsent = (
  cookieConsent: CookieConsent
): CookieConsent =>
  getUpdatedCookieConsent(cookieConsent, {
    functional: true,
    analytics: true,
    marketing: true,
    personalization: true,
  })

export const getOnlyEssentialCookieConsent = (
  cookieConsent: CookieConsent
): CookieConsent =>
  getUpdatedCookieConsent(cookieConsent, {
    functional: false,
    analytics: false,
    marketing: false,
    personalization: false,
  })
